import { Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "down-arrow-svg",
  templateUrl: "./down-arrow.component.svg",
  styleUrls: ["./down-arrow.component.scss"],
})
export class DownArrowSvgComponent {

  @Input() width: number;

  @HostBinding('style.width') get _width() {
    return this.width ? this.width + 'px' : '';
  }

  @Input() height: number;

  @HostBinding('style.height') get _height() {
    return this.height ? this.height + 'px' : '';
  }

  @Input() rotation: number;

  @HostBinding('style.transform') get _rotation() {
    return this.rotation ? 'rotate(' + this.rotation + 'deg)' : '';
  }
}
